import { Button, Stack, TextField, Typography, useTheme } from '@mui/material'
import { i18WithDefault as t } from '@shared/locales'
import { Auth } from 'aws-amplify'
import { FormikProps } from 'formik'
import { TFormikValues } from './signin_tooltip_content'
import { ContinueButton } from '../continue_button'

type VerifyEmailFormProps = {
  formik: FormikProps<TFormikValues>
  setShowVerifyForm: React.Dispatch<React.SetStateAction<boolean>>
  setCognitoUser: React.Dispatch<React.SetStateAction<null>>
}

export const VerifyEmailForm = ({ formik, setShowVerifyForm, setCognitoUser }: VerifyEmailFormProps) => {
  const theme = useTheme()

  const handleRequestNewCodeClick = () => {
    Auth.signIn(formik.values.email)
      .then((result) => {
        setCognitoUser(result)
      })
      .catch(() => {
        formik.setErrors({ email: t('global.sendCodeError') })
      })
  }

  const handleCorrectEmailClick = () => {
    formik.resetForm()
    setShowVerifyForm(false)
  }

  return (
    <Stack spacing={2}>
      <Stack>
        <Typography variant="body2" textAlign="center">
          {t('signin.verify.title')}
        </Typography>
        <Typography variant="caption" textAlign="center">
          {t('signin.verify.copy')}
        </Typography>
      </Stack>
      <TextField
        key="code"
        name="code"
        value={formik.values.code}
        placeholder={t('signin.verify.code')}
        size="small"
        onChange={formik.handleChange}
        onBlur={(e) => formik.setFieldValue('code', e.target.value.trim())}
        error={formik.touched.code && Boolean(formik.errors.code)}
        helperText={formik.touched.code && formik.errors.code}
        FormHelperTextProps={{ sx: { height: 'auto' } }}
      />
      <ContinueButton type="submit" loading={formik.isSubmitting} />
      <Button sx={{ color: theme.palette.primary.dark, p: 0 }} onClick={handleRequestNewCodeClick}>
        {t('signin.verify.requestNewCode')}
      </Button>
      <Button sx={{ color: theme.palette.primary.dark, p: 0 }} onClick={handleCorrectEmailClick}>
        {t('signin.verify.correctEmail')}
      </Button>
    </Stack>
  )
}
